import { clearNewItemPhotoCache } from "./newItemPhotoCache";

const TOKEN_KEY = "token";
const SESSION_KEY = "sessionExpiry";
const USER_KEY = "userData";

export function getAuthHeaders() {
  const token = localStorage.getItem(TOKEN_KEY);
  return token ? { Authorization: `Bearer ${token}` } : {};
}

function clearSessionAndRedirect() {
  try {
    clearNewItemPhotoCache();
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(SESSION_KEY);
    localStorage.removeItem(USER_KEY);
  } catch (e) {
    console.error("Session clear error:", e);
  }
  window.location.replace("/login?reason=session_expired");
}

/**
 * fetch wrapper that adds auth headers and redirects to login on 401.
 * Use this for all authenticated API calls.
 */
export async function authFetch(url, options = {}) {
  const mergedHeaders = { ...getAuthHeaders(), ...options.headers };
  const res = await fetch(url, { ...options, headers: mergedHeaders });
  if (res.status === 401 || res.status === 403) {
    clearSessionAndRedirect();
    throw new Error("Session expired. Please log in again.");
  }
  return res;
}
